<template>
  <v-tooltip top>
    <template #activator="{ on }">
      <v-icon
        :color="color"
        v-on="on"
      >
        fiber_manual_record
      </v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'FileUploadStatus',
  props: {
    color: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
};
</script>
